import { render, staticRenderFns } from "./Rmaterial.vue?vue&type=template&id=4addb696&scoped=true"
import script from "./Rmaterial.vue?vue&type=script&lang=js"
export * from "./Rmaterial.vue?vue&type=script&lang=js"
import style0 from "./Rmaterial.vue?vue&type=style&index=0&id=4addb696&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4addb696",
  null
  
)

export default component.exports